/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { Tooltip } from '../../../../Tooltip';
import { CellWithGridDropdown } from '../../DataGridCellWithDropdown/component/CellWithGridDropdown';
import './WithGridDropdownCellComponent.scss';
import '../../DataGridCellWithDropdown/component/CellWithGridDropdown.scss';
export const WithGridDropdownCellComponent = (gridDropdownProps) => ({ children, value }) => (React.createElement("td", { className: "dx-g-bs4-table-cell text-nowrap", colSpan: 1 },
    React.createElement(CellWithGridDropdown, { gridDropdownProps: gridDropdownProps, value: value },
        React.createElement(Tooltip, { className: "data-grid-tooltip-dropdown-cell", tip: value, forEllipsesText: true }, children))));
//# sourceMappingURL=WithGridDropdownCellComponent.js.map